import { SurveyElement } from '../survey-bundle/survey-bundle.interface';

export type ArgType =
  | 'text'
  | 'number'
  | 'date'
  | 'datetime'
  | 'time'
  | 'text_range'
  | 'number_range'
  | 'date_range'
  | 'single_select'
  | 'multi_select'
  | 'none'
  | 'matrix_row';

export interface Operator {
  slug: string;
  label: string;
  argType: ArgType;
}

export const OPERATORS: Record<string, Operator> = {
  // Choice Logic
  is: { slug: 'is', label: 'Is', argType: 'single_select' },
  is_not: { slug: 'is_not', label: 'Is Not', argType: 'single_select' },
  inc_any: { slug: 'inc_any', label: 'Includes Any', argType: 'multi_select' },
  inc_all: { slug: 'inc_all', label: 'Includes All', argType: 'multi_select' },
  is_ex: { slug: 'is_ex', label: 'Is Exactly', argType: 'multi_select' },

  // Text Logic
  eq_text: { slug: 'eq_text', label: 'Equals', argType: 'text' },
  cont: { slug: 'cont', label: 'Contains', argType: 'text' },
  sw: { slug: 'sw', label: 'Starts With', argType: 'text' },

  // Numeric Logic
  eq_num: { slug: 'eq_num', label: 'Equals', argType: 'number' },
  neq_num: { slug: 'neq_num', label: 'Not Equals', argType: 'number' },
  gt: { slug: 'gt', label: 'Greater Than', argType: 'number' },
  lt: { slug: 'lt', label: 'Less Than', argType: 'number' },
  bet_num: { slug: 'bet_num', label: 'Between', argType: 'number_range' },

  // Date/Time Logic
  on_date: { slug: 'on_date', label: 'On', argType: 'date' },
  bef_date: { slug: 'bef_date', label: 'Before', argType: 'date' },
  aft_date: { slug: 'aft_date', label: 'After', argType: 'date' },
  bet_date: { slug: 'bet_date', label: 'Between', argType: 'date_range' },

  // State Logic
  ans: { slug: 'ans', label: 'Answered', argType: 'none' },
  nans: { slug: 'nans', label: 'Not Answered', argType: 'none' },
  liked: { slug: 'liked', label: 'Liked', argType: 'none' },
  disliked: { slug: 'disliked', label: 'Disliked', argType: 'none' },

  // Matrix / Ordering
  rank_is: {
    slug: 'rank_is',
    label: 'Rank of [Option] is',
    argType: 'single_select',
  },
  sum_is: { slug: 'sum_is', label: 'Sum is', argType: 'number' },
  row_is: { slug: 'row_is', label: 'Row logic', argType: 'matrix_row' },
};

export interface Condition {
  id?: string;
  condition_set_id?: string;
  condition_element_id: number;
  operator: string;
  option_id?: string;
  value_manual?: any;
  option_targets?: string[];
  rank: number;
}

export enum ConditionSetElementType {
  QUESTION_ELEMENT = 'questionElement',
  LOGIC_ELEMENT = 'logicElement',
  ENDING = 'ending',
}
export interface ConditionSet {
  id: string;
  skip_logic_id?: string;
  logical_operator: 'AND' | 'OR';
  description: string;
  conditions: Condition[];
  condition_set_element_id?: number;
  condition_set_element_type: ConditionSetElementType;
}

export interface ComposedCondition extends Condition {
  /** * Pre-resolved on server.
   * Essential because the client can't fetch options from the bundle.
   */
  option_key: number;

  /** * NEW: The type of the question (e.g., 'numeric', 'single-choice').
   * The client uses this to determine which OPERATOR_FUNCTIONS to run.
   */
  element: SurveyElement;

  option_keys: number[];
}

export interface ComposedConditionSet extends Omit<ConditionSet, 'conditions'> {
  conditions: ComposedCondition[];
  // Map of ElementID -> Value
  dependencies: Record<number, any>;
}
